import { contatti } from '@/lib/data';
import Link from 'next/link';
import {
  FaWhatsapp,
  FaMapMarkerAlt,
  FaRegEnvelope,
  FaRegClock,
} from 'react-icons/fa';

export default function Contacts() {
  return (
    <div className="flex flex-col text-ctext lg:col-span-3 col-span-12 lg:items-start items-center lg:pt-0 pt-12">
      <p className="text-primary-900 font-bold pb-2 text-2xl">Contatti</p>
      <p className="text-secondary/90 flex gap-2 font-lato font-bold items-center text-center md:text-start">
        <FaWhatsapp className="text-primary-500 text-lg" />
        {contatti.numero}
      </p>
      <Link
        className="text-secondary/90 flex gap-2 font-lato font-bold items-center text-center md:text-start w-[70%] md:w-full hover:underline underline-offset-4"
        href={'https://maps.app.goo.gl/Ef5Kcpr8bwiKEm8V8'}
        target="_blank">
        <FaMapMarkerAlt className="text-primary-500 text-lg" />
        {contatti.indirizzo}
      </Link>
      <p className="text-secondary/90 flex gap-2 font-lato font-bold items-center text-center md:text-start">
        <FaRegEnvelope className="text-primary-500 text-lg" />
        {contatti.email}
      </p>
      <p className="text-secondary/90 flex gap-2 font-lato font-bold items-center text-center md:text-start">
        <FaRegClock className="text-primary-500 text-lg" />
        {contatti.orari}
      </p>
    </div>
  );
}
